(() => {
  'use strict';
  function categoryTags(tags, categories) {
    const allowed = new Set(categories);
    return [...new Set(tags.filter(tag => allowed.has(tag)))];
  }
  function searchQuery(tags) {
    return tags.map(tag => `tag:"${tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`).join(' OR ');
  }
  function selectMatches(items, currentId, tags, limit) {
    const wanted = new Set(tags);
    const seen = new Set([String(currentId)]);
    return items.filter(item => {
      const id = String(item.id);
      if (seen.has(id) || !item.tags.some(tag => wanted.has(tag))) return false;
      seen.add(id);
      return true;
    }).slice(0, limit);
  }
  class HpmTagRelated extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tags = categoryTags(JSON.parse(this.dataset.tags), JSON.parse(this.dataset.categories));
      this.grid = this.querySelector('[data-related-grid]');
      this.status = this.querySelector('[data-related-status]');
      this.retry = this.querySelector('[data-related-retry]');
      this.retry.addEventListener('click', () => this.load());
      if (!this.tags.length) { this.hidden = true; return; }
      this.load();
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      this.hidden = false;
      this.setAttribute('aria-busy', 'true');
      this.status.hidden = false;
      this.status.textContent = '正在尋找同類產品…';
      this.retry.hidden = true;
      try {
        const url = new URL(this.dataset.searchUrl, window.location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', searchQuery(this.tags));
        url.searchParams.set('options[unavailable_products]', 'last');
        url.searchParams.set('section_id', 'hpm-tag-related-results');
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-related-results]');
        if (!results) throw new Error('Missing results section');
        const candidates = [...results.querySelectorAll('[data-related-product]')].map(node => ({
          id: node.dataset.productId, tags: JSON.parse(node.dataset.productTags), node
        }));
        const matches = selectMatches(candidates, this.dataset.productId, this.tags, Number(this.dataset.limit) || 5);
        this.grid.replaceChildren(...matches.map(item => item.node));
        this.status.hidden = true;
        this.hidden = !matches.length;
      } catch (_) {
        this.grid.replaceChildren();
        this.status.textContent = '同類產品暫時未能載入，請稍後再試。';
        this.retry.hidden = false;
      } finally {
        this.loading = false;
        this.setAttribute('aria-busy', 'false');
      }
    }
  }
  if (!customElements.get('hpm-tag-related')) customElements.define('hpm-tag-related', HpmTagRelated);
  if (typeof module !== 'undefined' && module.exports) module.exports = { categoryTags, searchQuery, selectMatches, HpmTagRelated };
})();
